module.exports = __webpack_public_path__ + "assets/03c02ab71e93eeb9397d092258c7dfd2.mp3";